import './Board.css';
import Files from './bits/Files';
import Ranks from './bits/Ranks';
import Pieces from '../Pieces/Pieces';
import Popup from '../Popup/Popup';
import { useAppContext } from '../../contexts/Context';
import { getKingPosition } from '../../arbiter/getMoves';
import arbiter from '../../arbiter/arbiter';
import PromotionBox from '../Popup/PromotionBox/PromotionBox';
import GameEnds from '../Popup/GameEnds/GameEnds';

const Board = () => {
    const ranks = Array(8).fill().map((x, i) => 8 - i);
    const files = Array(8).fill().map((x, i) => i + 1);

    const { appState } = useAppContext()
    const position = appState.game[appState.game.length - 1].position;

    const isChecked = (() => {
        const isInCheck = (arbiter.isPlayerInCheck({
            positionAfterMove: position,
            player: appState.turn
        }));

        if (isInCheck) {
            return getKingPosition(position, appState.turn);
        }

        return null;
    })();

    const getClassName = (i, j) => {
        let c = 'tile';
        c += (i + j) % 2 === 0 ? ' tile--dark' : ' tile--light';

        if (appState.candidateMoves?.find(m => m[0] === i && m[1] === j)) {
            if (position[i][j]) {
                c += ' attacking';
            } else {
                c += ' highlight';
            }
        }

        if (isChecked && isChecked[0] === i && isChecked[1] === j) {
            c += ' checked';
        }

        return c;
    }

    return (
        <div className="board">

            <Ranks ranks={ranks} />

            <div className={`tiles ${appState.flipped ? 'tiles-flipped' : ''}`}>
                {ranks.map((rank, i) =>
                    files.map((file, j) =>
                        <div key={file + '-' + rank} className={`${getClassName(7 - i, j)}`}></div>
                    ))}
            </div>

            <Pieces />

            <Popup >
                <PromotionBox />
                <GameEnds />
            </Popup>

            <Files files={files} />

        </div>
    )
}

export default Board